import styled from "@emotion/styled";
import { SessionSentBadgeColor } from "./session-sent-badge.types";
import { Theme } from "@emotion/react";

type StyledContainerProps = {
  color?: SessionSentBadgeColor;
};

export const StyleContainerPlaceholder = styled.div`
  height: 24px;
`;

export const StyledContainer = styled.div<StyledContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  color: ${({ color, theme }) => getColor(theme, color)};
  gap: ${({ theme }) => theme.spacing.xs};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights.xsmall};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-2px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  svg {
    width: 16px;
    height: 16px;
    color: ${({ color, theme }) => getColor(theme, color)};
  }
`;

export const IconContainer = styled.div`
  height: 16px;
`;

const getColor = (theme: Theme, color?: SessionSentBadgeColor) => {
  switch (color) {
    case SessionSentBadgeColor.Green:
      return theme.colors.green.x500;
    default:
      return theme.colors.grey.x500;
  }
};
